<template>
  <div id="app">
    <!-- <public-top></public-top> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <public-bottom
      v-if="name == 'home' || name == 'classify' || name == 'mine'"
    ></public-bottom>
  </div>
</template>

<script>
// import PublicTop from './components/publicTop/index.vue'
import PublicBottom from "./components/publicBottom/index.vue";
export default {
  name: "App",
  data() {
    return {
      name: ""
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.name = val.name;
      }
    }
  },
  components: {
    // PublicTop,
    PublicBottom
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.getIpLogin();
    }
  },
  methods: {
    getIpLogin() {
      this.$http({
        url: `/user/ipLogin`,
        method: "get"
      }).then(res => {
        if (res.cxajaxrc == 0) {
          localStorage.setItem("token", res.returnvalue.token);
          this.$toast({
            message: "IP登录成功"
          });
          localStorage.setItem("isIpUser", true);
          setTimeout(() => {
            this.$router.replace({
              path: "/"
            });
          }, 800);
        } else {
          this.$router.replace({
            path: "/login"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
#app {
  color: #353535;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Medium;
  height: 100%;
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
}

.line2 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* -webkit-box-orient: vertical; */
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/App.vue